import { CD_LANGUAGE } from "@hooks/useAnalyticsCall/useBHCustomEventAnalyticsCall";
interface WindowData {
  title?: string;
}

export const scrollFlags = {
  isProgrammatic: false,
};

export const registerPlayerEvents = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  player: any,
  bhCustomEvent: ReturnType<
    (typeof import("@hooks/useAnalyticsCall/useBHCustomEventAnalyticsCall"))["useBHCustomEventAnalyticsCall"]
  >,
) => {
  let isFirstTime = true;

  const data = (window as { _data?: WindowData })._data;
  const articleTitle: string =
    typeof data?.title === "string" ? data.title : "";

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  player.addEventListener("VisibilityChanged", () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (player.widgetStyle === "closed-by-user") {
      bhCustomEvent(
        "speech",
        "remove",
        articleTitle,
        true,
        undefined,
        CD_LANGUAGE.MALAY,
      );
    }
    if (isFirstTime) {
      isFirstTime = false;
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (player?.userInterface?.isVisible !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      player.widgetStyle = player.userInterface.isVisible ? "none" : "standard";
    }
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  player.addEventListener("PlaybackEnded", () => {
    scrollFlags.isProgrammatic = true;
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  player.addEventListener("PressedChangeRate", () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    const playbackRate: string = player.playbackRate ?? "";
    bhCustomEvent(
      "speech",
      "click",
      articleTitle + "::speed::" + playbackRate + "x",
      true,
      undefined,
      CD_LANGUAGE.MALAY,
    );
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  player.addEventListener("PressedPrevSegment", () => {
    bhCustomEvent(
      "speech",
      "rewind",
      articleTitle,
      true,
      undefined,
      CD_LANGUAGE.MALAY,
    );
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  player.addEventListener("PressedNextSegment", () => {
    bhCustomEvent(
      "speech",
      "forward",
      articleTitle,
      true,
      undefined,
      CD_LANGUAGE.MALAY,
    );
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  player.addEventListener("PressedPause", () => {
    bhCustomEvent(
      "speech",
      "pause",
      articleTitle,
      true,
      undefined,
      CD_LANGUAGE.MALAY,
    );
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  player.addEventListener("PressedPlay", () => {
    bhCustomEvent(
      "speech",
      "play",
      articleTitle,
      true,
      undefined,
      CD_LANGUAGE.MALAY,
      "no",
    );
  });

  const element = document.querySelector('[data-testid="article-body"]');
  const styleMap = {
    PlaybackEnded: {
      userSelect: "auto",
      backgroundColor: "#F1F6FB",
      textColor: "#1E1E1E",
      iconColor: "#01519C",
    },
    PlaybackPaused: {
      userSelect: "auto",
      backgroundColor: "#F1F6FB",
      textColor: "#1E1E1E",
      iconColor: "#01519C",
    },
    PlaybackPlaying: {
      userSelect: "none",
      backgroundColor: "#01519C",
      textColor: "#FAFAFA",
      iconColor: "#FAFAFA",
    },
  } as const;

  (Object.keys(styleMap) as Array<keyof typeof styleMap>).forEach((event) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    player.addEventListener(event, () => {
      /* eslint-disable @typescript-eslint/no-unsafe-member-access */
      player.backgroundColor = styleMap[event].backgroundColor;
      player.textColor = styleMap[event].textColor;
      player.iconColor = styleMap[event].iconColor;
      /* eslint-enable @typescript-eslint/no-unsafe-member-access */
      if (element) {
        (element as HTMLElement).style.userSelect = styleMap[event].userSelect;
      }
    });
  });
};
